/**
 * Shared layout tokens for Patients module pages.
 * Re-exports global page chrome (Patient module is the design source of truth).
 */
export {
  PAGE_SHELL as PATIENT_PAGE_SHELL,
  PAGE_STACK as PATIENT_PAGE_STACK,
} from "../../ui/pageChrome";

/**
 * Patient detail split layout (lg+):
 * - Fills the app main viewport under Navbar (h-14) + main padding (~2.5rem)
 * - Left summary / Care Team stays put; right tab content scrolls
 *
 * Mobile: natural document flow (stacked sidebar above content).
 *
 * Navbar = 3.5rem (APP_HEADER_H). Main padding ≈ p-4/p-5 → use 2.5rem.
 */
export const PATIENT_DETAIL_VIEWPORT =
  "w-full flex flex-col gap-3 lg:h-[calc(100dvh-3.5rem-2.5rem)] lg:min-h-0 lg:overflow-hidden";

export const PATIENT_DETAIL_SPLIT =
  "flex flex-1 min-h-0 flex-col lg:flex-row items-stretch bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden";

/** Summary / Care Team column — fixed header; inner panel scrolls sections. */
export const PATIENT_DETAIL_SIDEBAR =
  "w-full lg:w-[240px] xl:w-[250px] 2xl:w-[260px] shrink-0 lg:border-r border-b lg:border-b-0 border-slate-200 rounded-t-xl lg:rounded-tr-none lg:rounded-l-xl bg-white lg:h-full lg:min-h-0 lg:overflow-hidden flex flex-col";

/** Tabs + panel shell */
export const PATIENT_DETAIL_MAIN =
  "min-w-0 flex-1 w-full flex flex-col overflow-hidden rounded-b-xl lg:rounded-bl-none lg:rounded-r-xl bg-white lg:h-full lg:min-h-0";

/** Scrollable tab body (tables / forms) */
export const PATIENT_DETAIL_MAIN_SCROLL =
  "flex-1 min-h-0 overflow-y-auto overscroll-contain bg-slate-50/50 p-3 sm:p-4";
